import 'react';

const CircleTickSvg = (): React.PropsWithoutRef<React.ReactSVGElement> => (
    <svg width="12px" height="12px" viewBox="0 0 12 12" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
        <g id="最终稿" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g id="发布到个人主页后，文档页信息变化" transform="translate(-487.000000, -22.000000)">
                <g id="头部/组/预览态/文档名" transform="translate(258.000000, 0.000000)">
                    <g id="编组-2" transform="translate(223.000000, 19.000000)">
                        <g id="编组-8" transform="translate(6.000000, 3.000000)">
                            <rect id="矩形" x="0" y="0" width="12" height="12"></rect>
                            <circle
                                id="椭圆形"
                                stroke="#31BD77"
                                strokeWidth="1.2"
                                opacity="0.900000036"
                                cx="6"
                                cy="6"
                                r="4.4"
                            >
                            </circle>
                            <path
                                d="M4.21175588,6.15655583 L5.51335603,7.36058726 L7.9334544,4.85969349"
                                id="路径-2"
                                stroke="#31BD77"
                                strokeWidth="1.2"
                                opacity="0.900000036"
                            >
                            </path>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
);
export default CircleTickSvg;
